/**
 * @file link.component.tsx
 * @description Компонент для отображения и работы с внешней ссылкой в списке вложений с контекстным меню
 * @author AI-Generated | Human-Reviewed
 * @created 2025-09-03
 * @updated 2025-09-10
 * @dependencies ['@consta/icons/IconKebab', '@consta/uikit/ContextMenu', '@consta/uikit/Text', '@src/components/icons/edit-file-round/edit-file-round.icon', '@components/icons/close-file-round/close-file-roind.icon', 'react', '@consta/icons/IconWorldStroked', '@forms/modals/link.modal', '@src/types']
 * @related-files ['src/components/ui/data/attachment-list/attachment-list.component.tsx']
 */

import { IconKebab } from '@consta/icons/IconKebab';
import { ContextMenu } from '@consta/uikit/ContextMenu';
import { Text } from '@consta/uikit/Text';
import { EditFileRoundIcon } from '@src/components/icons/edit-file-round/edit-file-round.icon';
import { CloseFileRoundIcon } from '@components/icons/close-file-round/close-file-roind.icon';
import { useEffect, useMemo, useRef, useState } from 'react';
import { IconWorldStroked } from '@consta/icons/IconWorldStroked';
import { LinkModal } from '@forms/modals/link.modal';
import { IAttachmentComponentProps } from '../attachment-list.component';
import { TAttachment } from '@src/types';

export const Link = ({ onChange, attachment }: IAttachmentComponentProps) => {
    const [isShowContext, setIsShowContext] = useState<boolean>(false);
    const [isShowLinkModal, setIsShowLinkModal] = useState<boolean>(false);
    const anchorRef = useRef<HTMLElement | null>(null);
    const currentFile = useRef<TAttachment | null>(null);

    useEffect(() => {
        if (!setIsShowContext) {
            currentFile.current = null;
        }
    }, [setIsShowContext]);

    const contextMenuItems = useMemo(
        () => [
            {
                label: 'Удалить',
                icon: <CloseFileRoundIcon className="hidden-buttons__button" />,
                onClick: () => {
                    currentFile.current && onChange(currentFile.current, 'delete');
                    setIsShowContext(false);
                }
            },
            {
                label: 'Редактировать',
                icon: <EditFileRoundIcon className="hidden-buttons__button" />,
                onClick: () => setIsShowLinkModal(true)
            }
        ],
        []
    );

    const onKebabButtonClick = (e: React.MouseEvent<HTMLElement>) => {
        anchorRef.current = e.target as HTMLElement;
        setIsShowContext(true);
    };

    return (
        <>
            <a href={attachment.link} className="flex items-center" target="_blank">
                <IconWorldStroked size="xs" view="brand" />

                <Text
                    view="primary"
                    size="m"
                    className="attachment-list__file_name break-all text-[#045A9A] cursor-pointer hover:text-link-hover"
                >
                    {attachment.name}
                </Text>
            </a>

            <div className="attachment-list__file_button h-full cursor-pointer">
                <IconKebab
                    size="xs"
                    view="brand"
                    onClick={(e) => {
                        onKebabButtonClick(e);
                        currentFile.current = attachment;
                    }}
                />
            </div>

            {isShowLinkModal && (
                <LinkModal
                    item={attachment}
                    isShow={isShowLinkModal}
                    title="Изменить ссылку"
                    setIsShow={setIsShowLinkModal}
                    addItemHandler={(newAttachment: TAttachment) => {
                        onChange(newAttachment, 'edit', attachment);
                    }}
                />
            )}

            <ContextMenu
                items={contextMenuItems}
                isOpen={isShowContext}
                anchorRef={anchorRef}
                getItemLeftSide={(item) => item.icon}
                onClickOutside={() => setIsShowContext(false)}
                direction="downStartRight"
                style={{ pointerEvents: 'auto' }}
                className="absolute"
            />
        </>
    );
};
